import { __decorate, __metadata } from 'tslib';
import { Injectable, NgModule } from '@angular/core';
import { FormControl, FormGroup, FormArray, FormBuilder, ReactiveFormsModule } from '@angular/forms';

import * as ɵngcc0 from '@angular/core';
class TypedFormControl extends FormControl {
    constructor(formState = null, validatorOrOpts, asyncValidator) {
        super(formState, validatorOrOpts, asyncValidator);
    }
    setValue(value, options) {
        super.setValue(value, options);
    }
    patchValue(value, options = {}) {
        super.patchValue(value, options);
    }
    reset(formState = null, options = {}) {
        super.reset(formState, options);
    }
}
class TypedFormGroup extends FormGroup {
    constructor(controls, options, asyncValidator) {
        super(controls, options, asyncValidator);
    }
    setValue(value, options = {}) {
        super.setValue(value, options);
    }
    patchValue(value, options = {}) {
        super.patchValue(value, options);
    }
    reset(value = {}, options = {}) {
        super.reset(value, options);
    }
    getRawValue() {
        return super.getRawValue();
    }
}
class TypedFormArray extends FormArray {
    constructor(controls, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
    }
    setValue(value, options) {
        super.setValue(value, options);
    }
    patchValue(value, options = {}) {
        super.patchValue(value, options);
    }
    getRawValue() {
        return super.getRawValue();
    }
}

let TypedFormBuilder = class TypedFormBuilder extends FormBuilder {
    constructor() {
        super();
        this._fb = new FormBuilder();
        this._fb.control = this.control;
    }
    group(controlsConfig, options) {
        const { controls, updateOn, validator, asyncValidator } = this._fb.group(controlsConfig, options);
        return new TypedFormGroup(controls, {
            asyncValidators: asyncValidator,
            validators: validator,
            updateOn,
        });
    }
    control(formState, validatorOrOpts, asyncValidator) {
        return new TypedFormControl(formState, validatorOrOpts, asyncValidator);
    }
    array(controlsConfig, validatorOrOpts, asyncValidator) {
        const ctrl = this._fb.array(controlsConfig, validatorOrOpts, asyncValidator);
        return new TypedFormArray(ctrl.controls, {
            asyncValidators: ctrl.asyncValidator,
            updateOn: ctrl.updateOn,
            validators: ctrl.validator,
        });
    }
};
TypedFormBuilder.ɵfac = function TypedFormBuilder_Factory(t) { return new (t || TypedFormBuilder)(); };
TypedFormBuilder.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: TypedFormBuilder, factory: function (t) { return TypedFormBuilder.ɵfac(t); } });
TypedFormBuilder = __decorate([ __metadata("design:paramtypes", [])
], TypedFormBuilder);

let TypedReactiveFormsModule = class TypedReactiveFormsModule {
};
TypedReactiveFormsModule.ɵfac = function TypedReactiveFormsModule_Factory(t) { return new (t || TypedReactiveFormsModule)(); };
TypedReactiveFormsModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: TypedReactiveFormsModule });
TypedReactiveFormsModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ providers: [TypedFormBuilder], imports: [[ReactiveFormsModule], ReactiveFormsModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TypedFormBuilder, [{
        type: Injectable
    }], function () { return []; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TypedReactiveFormsModule, { imports: function () { return [ReactiveFormsModule]; }, exports: function () { return [ReactiveFormsModule]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TypedReactiveFormsModule, [{
        type: NgModule,
        args: [{
                declarations: [],
                imports: [ReactiveFormsModule],
                exports: [ReactiveFormsModule],
                providers: [TypedFormBuilder]
            }]
    }], null, null); })();

/*
 * Public API Surface of formsafe
 */

/**
 * Generated bundle index. Do not edit.
 */

export { TypedFormArray, TypedFormBuilder, TypedFormControl, TypedFormGroup, TypedReactiveFormsModule };

//# sourceMappingURL=formsafe.js.map